// export const server = "https://backend.devservertd.com/api/v2";
//export const server = "http://localhost:8000/api/v2";
// export const socket = "https://sockets.devservertd.com/"
//export const socket = "http://localhost:4000/";

// export const backend_url = "https://backend.devservertd.com/";
//export const backend_url = "https://wof2-s2qk.vercel.app/";
//export const backend_url = "http://localhost:8000/";

 export const server = "https://backend.waysoffood.co.uk/api/v2";
 export const backend_url = "https://backend.waysoffood.co.uk/";
 export const socket = "https://sockets.waysoffood.co.uk";

export const STRIPE_API_KEY =
  "pk_test_51R5VnCK1yLrrBxuY3brlKTPah3ptFhd8H9vhLjZdnfTo7qx1jLFO6pNFI0gtyRPxlwrI84WtJf7b6T7UKhqq8U3C00qumg3gqz";
